import React from 'react'

const AdminAnalyticsPage: React.FC = () => {
  const stats = {
    totalUsers: 1250,
    activeUsers: 890,
    totalRevenue: 45600,
    monthlyGrowth: 12.5,
    topDestinations: [
      { name: 'Gran Sasso', visits: 450 },
      { name: 'Costa dei Trabocchi', visits: 380 },
      { name: 'Rocca Calascio', visits: 320 },
      { name: 'Santo Stefano di Sessanio', visits: 280 }
    ],
    recentActivity: [
      { type: 'registration', user: 'mario@example.com', time: '2 ore fa' },
      { type: 'booking', user: 'anna@example.com', time: '3 ore fa' },
      { type: 'payment', user: 'luca@example.com', time: '5 ore fa' },
      { type: 'contact', user: 'giulia@example.com', time: '6 ore fa' }
    ]
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-6">
            Analytics Dashboard
          </h3>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="bg-blue-50 p-6 rounded-lg">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-blue-500 rounded-md flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-blue-600">Utenti Totali</p>
                  <p className="text-2xl font-semibold text-blue-900">{stats.totalUsers}</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 p-6 rounded-lg">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-green-500 rounded-md flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-green-600">Utenti Attivi</p>
                  <p className="text-2xl font-semibold text-green-900">{stats.activeUsers}</p>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-yellow-500 rounded-md flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-yellow-600">Revenue Totale</p>
                  <p className="text-2xl font-semibold text-yellow-900">€{stats.totalRevenue.toLocaleString()}</p>
                </div>
              </div>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-purple-500 rounded-md flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-purple-600">Crescita Mensile</p>
                  <p className="text-2xl font-semibold text-purple-900">+{stats.monthlyGrowth}%</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Top Destinations */}
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h4 className="text-lg font-medium text-gray-900 mb-4">Destinazioni Più Popolari</h4>
              <div className="space-y-4">
                {stats.topDestinations.map((destination, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center">
                      <span className="text-sm font-medium text-gray-500 w-6">{index + 1}</span>
                      <span className="text-sm font-medium text-gray-900">{destination.name}</span>
                    </div>
                    <span className="text-sm text-gray-500">{destination.visits} visite</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Recent Activity */}
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h4 className="text-lg font-medium text-gray-900 mb-4">Attività Recenti</h4>
              <div className="space-y-3">
                {stats.recentActivity.map((activity, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className={`w-2 h-2 rounded-full ${
                      activity.type === 'registration' ? 'bg-blue-500' :
                      activity.type === 'booking' ? 'bg-green-500' :
                      activity.type === 'payment' ? 'bg-yellow-500' :
                      'bg-purple-500'
                    }`}></div>
                    <div className="flex-1">
                      <p className="text-sm text-gray-900">
                        {activity.type === 'registration' ? 'Nuova registrazione' :
                         activity.type === 'booking' ? 'Nuova prenotazione' :
                         activity.type === 'payment' ? 'Pagamento ricevuto' :
                         'Nuovo messaggio'}
                      </p>
                      <p className="text-xs text-gray-500">{activity.user} • {activity.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Charts Placeholder */}
          <div className="mt-8">
            <h4 className="text-lg font-medium text-gray-900 mb-4">Grafici</h4>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-gray-50 rounded-lg p-6 h-64 flex items-center justify-center">
                <p className="text-gray-500">Grafico Visite Mensili</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 h-64 flex items-center justify-center">
                <p className="text-gray-500">Grafico Revenue</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminAnalyticsPage 